import { Component, OnInit, Input, OnChanges, DoCheck, KeyValueDiffers } from '@angular/core';
import { ReportsService } from '../reports.service';
import * as shape from 'd3-shape';

@Component({
  selector: 'app-sale-statistics',
  templateUrl: './sale-statistics.component.html',
  styleUrls: ['./sale-statistics.component.less']
})
export class SaleStatisticsComponent implements OnInit {
  @Input('filter') filter: any;
  loaded = false;
  data: any = {
    periodStatistics: [],
    eventAmoutStatistics: [],
    eventTicketsStatistics: []
  };

  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = true;
  showXAxisLabel = true;
  showYAxisLabel = true;
  curve = shape.curveCardinal;

  colorScheme = {
    domain: ['#a3a0fb', '#ffda82', '#fe8373', '#54d8fe', '#993399', '#FF0000', '#18B265', '#0E55A0']
  };

  constructor(private service: ReportsService) {
  }

  ngOnInit() {
    this.load();
  }

  public load() {
    if (!!this.filter.event) {
      return;
    }

    this.service.saleStatistics(this.filter)
      .subscribe(data => {
        this.data = data;
        this.loaded = true;
      });
  }

}
